var _circle, _path, _rect, _rect2, _rect3, _mask, _path2, _path3, _rect4, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadMultiFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_21424_216)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7987 9.7765L58 8.58531L54.8724 7.4215L53.5993 4L52.358 7.33581L49 8.58531L52.4317 9.86219L53.5993 13L54.7987 9.7765Z",
    fill: "#BDC3C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.99997,
    y: 23.8342,
    width: 47.9994,
    height: 32.1658,
    rx: 0.91954,
    fill: "#BDC3C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 18.5261,
    height: 7.45566,
    rx: 0.91954,
    fill: "#BDC3C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.68415,
    y: 27.4554,
    width: 44.631,
    height: 24.0711,
    rx: 0.91954,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_21424_216",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 55.0802C8.00003 55.5881 8.41173 55.9998 8.91957 55.9998L55.0799 55.9998C55.5877 55.9998 55.9994 55.5881 55.9994 55.0802L55.9994 34.5523C55.9994 34.0445 55.5877 33.6328 55.0799 33.6328L8.91958 33.6328C8.41173 33.6328 8.00004 34.0445 8.00004 34.5523L8.00003 55.0802Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 55.0802C8.00003 55.5881 8.41173 55.9998 8.91957 55.9998L55.0799 55.9998C55.5877 55.9998 55.9994 55.5881 55.9994 55.0802L55.9994 34.5523C55.9994 34.0445 55.5877 33.6328 55.0799 33.6328L8.91958 33.6328C8.41173 33.6328 8.00004 34.0445 8.00004 34.5523L8.00003 55.0802Z",
    fill: "#D4DADF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 55.0802C8.00003 55.842 8.61757 56.4595 9.37934 56.4595L54.6201 56.4595C55.3819 56.4595 55.9994 55.842 55.9994 55.0802L55.9994 55.0802C55.9994 55.3341 55.5877 55.54 55.0799 55.54L8.91957 55.54C8.41173 55.54 8.00003 55.3341 8.00003 55.0802L8.00003 55.0802ZM55.9994 33.6328L8.00004 33.6328L55.9994 33.6328ZM8.00004 33.6328L8.00003 55.9998L8.00004 33.6328ZM55.9994 55.9998L55.9994 33.6328L55.9994 55.9998Z",
    fill: "#8E9EAE",
    mask: "url(#path-6-inside-1_21424_216)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 18.5261,
    height: 7.45566,
    rx: 0.91954,
    transform: "matrix(-1 0 0 1 55.9999 29.7985)",
    fill: "#D4DADF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3836 44.7373L32.4349 41.7326C32.4813 41.6795 32.5374 41.6396 32.6032 41.6131C32.6689 41.5865 32.7404 41.5732 32.8178 41.5732C32.8874 41.5732 32.9531 41.5865 33.015 41.6131C33.0769 41.6396 33.131 41.6795 33.1774 41.7326L36.2635 44.7487C36.3641 44.8473 36.4124 44.9687 36.4086 45.1129C36.4047 45.257 36.3486 45.3784 36.2403 45.4771C36.1398 45.5681 36.016 45.6156 35.8691 45.6194C35.7221 45.6231 35.5984 45.5757 35.4978 45.4771L33.3399 43.3601L33.3399 48.3338C33.3399 48.478 33.2896 48.5994 33.189 48.698C33.0885 48.7967 32.9647 48.846 32.8178 48.846C32.6554 48.846 32.5258 48.7967 32.4291 48.698C32.3324 48.5994 32.2841 48.478 32.2841 48.3338L32.2841 43.3601L30.1146 45.4885C30.0063 45.5871 29.8806 45.6345 29.7375 45.6307C29.5944 45.6269 29.4764 45.5757 29.3836 45.4771C29.2753 45.3709 29.2212 45.2457 29.2212 45.1015C29.2212 44.9573 29.2753 44.8359 29.3836 44.7373Z",
    fill: "#5E6974"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21424_216",
    x1: 25.0115,
    y1: -108.874,
    x2: 32,
    y2: 89.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMultiFile);
export default __webpack_public_path__ + "static/media/upload-multi-file.e30dca43bf927e7ff34ea5fb4bd38744.svg";
export { ForwardRef as ReactComponent };